import KVideoPlayer from './KVideoPlayer';

export default KVideoPlayer;
